import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getFilterByIdAndType } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useOccConfig } from '../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { CompositeFilterInline } from './subcomponents/inline';
import { CompositeFilterModal } from './subcomponents/modal';
import { CompositeFilterSkeleton } from './subcomponents/skeleton';
import { CompositeFilterDisplayMode as DisplayMode } from './types/display-mode';
import { compositeFilterPropsValidator, defaultCompositeFilterPropsProvider } from './types/props';
const b = bemClassBuilder('v-composite-filter');
export const CompositeFilter = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { filterId, config, displayText, assets, cdnOptions } = props;
    const { filters, filterType, displayMode } = config;
    const filter = getFilterByIdAndType(filterId, filterType);
    const sectionsToDisplay = getEnabledFilterSections(filters);
    if (!filter) {
        return enableSkeletonLoadingIndicators ? (_jsx(CompositeFilterSkeleton, { displayMode: displayMode, numberOfSections: sectionsToDisplay.length })) : null;
    }
    const childProps = {
        filter,
        sectionsToDisplay,
        displayText,
        isAnchoredToTop: config.isFilterModalAnchoredToTop,
        filterModalButtonIconName: assets.filterModalButtonIconName,
        cdnOptions
    };
    const showInline = displayMode === DisplayMode.Inline || displayMode === DisplayMode.Auto;
    const showModal = displayMode === DisplayMode.Modal || displayMode === DisplayMode.Auto;
    return (_jsxs("div", Object.assign({ className: b.block({ displayMode }) }, { children: [showInline && _jsx(CompositeFilterInline, Object.assign({}, childProps)), showModal && _jsx(CompositeFilterModal, Object.assign({}, childProps))] })));
});
CompositeFilter.displayName = 'CompositeFilter';
const getEnabledFilterSections = (filters) => {
    return Object.entries(filters)
        .filter(([, config]) => config.enabled)
        .sort(([, configA], [, configB]) => configA.index - configB.index)
        .map(([key, config]) => ({ key, isMultiselect: config.isMultiselect }));
};
/**
 * The **Composite Filter** component allows a user to filter films, showtimes, or subscriptions.
 */
export const CompositeFilterComponent = withComponentWrapper(CompositeFilter, defaultCompositeFilterPropsProvider, compositeFilterPropsValidator);
